import { Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as emojiFlags from 'emoji-flags';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-form-field-emoji',
  templateUrl: './emoji-form-field.component.html',
  standalone: false,
})
export class EmojiFormFieldComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  getEmoji() {
    const contryCode = emojiFlags.countryCode(this.data);
    return contryCode ? contryCode.emoji : this.data;
  }

  ngOnDestroy() {}
}
